import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import PricingSection from "../HomeComonents/PricingSection";
import Header from "../../Components/Menu/Header";
import MsbBenefits from "../HomeComonents/MsbBenefits";
import { Helmet } from "react-helmet";
import Testimonials from "../HomeComonents/Testimonials";
import PhotoGallery from "../Gallery/PhotoGallery.jsx";
// import EventSlider1 from "./EventSlider1.jsx";
import VideoGallery from "../Gallery/VideoGallery.jsx";
import HeroSectionWebinarBan from "../HomeComonents/HeroSection old/HeroSection-MSB Meet Video.jsx";
import EventSlider1 from "./EventSlider1.jsx";
import HeroSection from "../HomeComonents/HeroSection old/HeroSection-SmoothSwap.jsx";
import DiscussionPanelists from "../HomeComonents/DiscussionPanelists.jsx";
// import HeroSection from "../HomeComonents/HeroSection.jsx";

// import EventSlider from './EventSlider';
// import EventSlider1 from './EventSlider1';
const Home = () => {
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const badgeRef = useRef(null);
  // Check if elements are in view
  const inView1 = useInView(ref1, { once: false });
  const inView2 = useInView(ref2, { once: false });
  const inView3 = useInView(ref3, { once: false });
  const inView4 = useInView(ref4, { once: false });
  const inView5 = useInView(ref5, { once: false });
  const badgeInView = useInView(badgeRef, { once: false });

  const [showAdditionalServices, setShowAdditionalServices] = useState(false);

  const handleReadMoreClick = () => {
    setShowAdditionalServices(!showAdditionalServices); // Toggle visibility
  };

  const [isExpanded, setIsExpanded] = useState({
    service1: false,
    service2: false,
    service3: false,
    service4: false,
    service5: false,
  });

  const toggleExpand = (serviceKey) => {
    setIsExpanded((prevState) => ({
      ...prevState,
      [serviceKey]: !prevState[serviceKey],
    }));
  };

  // Check if the badge element is in view
  const isBadgeInView = useInView(badgeRef, { once: false });

  // Parent animation to control stagger effect
  const badgeContainerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3, // Stagger each child by 0.3 seconds
      },
    },
  };

  // Individual children animations
  const badgeItemVariants = {
    hidden: { opacity: 0, y: 20 }, // Starts invisible and slightly below
    visible: {
      opacity: 1,
      y: 0, // Moves into view
      transition: { duration: 0.6 }, // Individual fade-in duration
    },
  };

  const headingVariants = {
    hidden: { opacity: 0, y: 20 }, // Starts hidden and below
    visible: {
      opacity: 1,
      y: 0, // Fades in and moves up to normal position
      transition: { duration: 0.8, delay: 1 }, // Slight delay after badge items
    },
  };
  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>
          {" "}
          MSB Association UK | Empowering Money Service Businesses in UK
        </title>
        <meta
          name="description"
          content="Join the MSB Association, the hub for UK Money Service Businesses. Access compliance support, industry advocacy, and tools to grow and safeguard your business."
        />

        {/* Open Graph Meta Tags */}
        <meta
          property="og:image"
          content="https://msbassociationuk.org/assets/images/logo.svg"
        />
        <meta
          property="og:title"
          content="MSB Association UK | Empowering Money Service Businesses"
        />
        <meta
          property="og:description"
          content="Discover the MSB Association UK, your trusted partner in compliance, advocacy, and growth. Empowering Money Service Businesses across the UK."
        />
        <meta property="og:url" content="https://msbassociationuk.org" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="MSB Association UK | Empowering Money Service Businesses"
        />
        <meta
          name="twitter:description"
          content="Discover the MSB Association UK, your trusted partner in compliance, advocacy, and growth. Empowering Money Service Businesses across the UK."
        />
        <meta
          name="twitter:image"
          content="https://msbassociationuk.org/assets/images/logo.svg"
        />

        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Hero Section - Start

{/* Hero Section - Start
  ================================================== */}
        <HeroSection />
        {/* <HeroSectionWebinarBan/> */}
          {/* <EventSlider1 />  */}
        {/* <EventSlider /> */}
     
       
      
        {/* Hero Section - End
  ================================================== */}
  
   {/* Discussion Panelists Section - Start
  ================================================== */}
        {/* <DiscussionPanelists /> */}
        {/* Discussion Panelists Section - End
  ================================================== */}

   {/* Video Gallery Section Section - Start
  ================================================== */}
        {/* <VideoGallery /> */}
        {/* Video Gallery Section - End
  ================================================== */}

   {/* Photo Gallery Section Section - Start
  ================================================== */}
        <PhotoGallery />
        {/* Photo Gallery Section - End
  ================================================== */}
   
 {/* Testimonials Section Section - Start
  ================================================== */}
        <Testimonials />
        {/* Service Section - Start
  ================================================== */}
        <section
          className="service_section section_space section_decoration"
          style={{ overflowX: "hidden" }}
        >
          <div className="container">
            <div className="heading_block text-center">
              <motion.div
                className="badge style_2 text-uppercase"
                ref={badgeRef} // Reference for the useInView hook
                variants={badgeContainerVariants} // Stagger children animation
                initial="hidden" // Initial state for the animation
                animate={isBadgeInView ? "visible" : "hidden"} // Trigger the animation when in view
              >
                {/* Icon and Text - staggered animation */}

                <motion.span variants={badgeItemVariants}>
                  <i className="fa-solid fa-circle text-primary"></i> Why MSB
                  Association? <i className="fa-solid fa-circle text-primary"></i>
                </motion.span>
              </motion.div>
              <motion.h2
                ref={badgeRef} // Reference for the useInView hook
                variants={headingVariants} // Stagger children animation for h2
                initial="hidden" // Initial state for the animation
                animate={isBadgeInView ? "visible" : "hidden"} // Trigger based on scroll
                className="heading_text mb-0"
              >
                Addressing the Challenges Faced by MSB's
              </motion.h2>
            </div>

            <div className="service_blocks_group row gap-4 justify-content-center align-items-center">
              {/* First Service Block */}
              <motion.div
                className="col-lg-3 col-md-6 col-sm-6"
                initial={{ opacity: 0, x: 100 }}
                animate={
                  inView1 ? { opacity: 1, x: 0 } : { opacity: 0, x: 100 }
                }
                transition={{ duration: 0.6 }}
                ref={ref1}
              >
                <div className="service_block style_2">
                  <div className="service_icon">
                    <img src="assets/images/icons/1.svg" alt="Icon Dollar" />
                  </div>
                  <div className="service_content">
                    <h3 className="service_title">
                      <a href="">Regulatory Compliance</a>
                    </h3>
                    <div className="mb-0">
                      <p
                        className="mb-0"
                        style={{ display: "flex", gap: "10px" }}
                      >
                        <span>1.</span> Visits from regulatory bodies
                      </p>
                      <p
                        className="mb-0"
                        style={{ display: "flex", gap: "10px" }}
                      >
                        <span>2.</span> Queries from Regulatory bodies
                      </p>

                      {isExpanded.service1 && (
                        <>
                          {" "}
                          <p
                            className="mb-0"
                            style={{ display: "flex", gap: "10px" }}
                          >
                            <span>3.</span> Complex Regulations
                          </p>
                          <p
                            className="mb-0"
                            style={{ display: "flex", gap: "10px" }}
                          >
                            <span>4.</span> Frequent Updates in existing
                            Regulations
                          </p>
                        </>
                      )}
                    </div>
                    <button
                      className=" p-0"
                      onClick={() => toggleExpand("service1")}
                    >
                      {isExpanded.service1 ? "Show Less" : "Read More"}
                    </button>
                  </div>
                </div>
              </motion.div>

              {/* Second Service Block */}
              <motion.div
                className="col-lg-3 col-md-6 col-sm-6"
                initial={{ opacity: 0, x: 100 }}
                animate={
                  inView2 ? { opacity: 1, x: 0 } : { opacity: 0, x: 100 }
                }
                transition={{ duration: 0.6, delay: 0.2 }}
                ref={ref2}
              >
                <div className="service_block style_2">
                  <div className="service_icon">
                    <img src="assets/images/icons/3.svg" alt="Icon Dollar" />
                  </div>
                  <div className="service_content">
                    <h3 className="service_title">
                      <a href="">
                        Risk <br /> Management <br />
                        <br />
                      </a>
                    </h3>
                    <div className="mb-0">
                      <p
                        className="mb-0"
                        style={{ display: "flex", gap: "10px" }}
                      >
                        <span>1.</span> Reputational Risk
                      </p>

                      <p
                        className="mb-0"
                        style={{ display: "flex", gap: "10px" }}
                      >
                        <span>2.</span> Cybersecurity Risk
                      </p>

                      {isExpanded.service2 && (
                        <>
                          <p
                            className="mb-0"
                            style={{ display: "flex", gap: "10px" }}
                          >
                            <span>3.</span> Fraud Risk
                          </p>

                          <p
                            className="mb-0"
                            style={{ display: "flex", gap: "10px" }}
                          >
                            <span>4.</span> Money Laundering, Terrorist
                            Financing and Proliferation Financing Risks
                          </p>
                        </>
                      )}
                    </div>
                    <button
                      className=" p-0"
                      onClick={() => toggleExpand("service2")}
                    >
                      {isExpanded.service2 ? "Show Less" : "Read More"}
                    </button>
                  </div>
                </div>
              </motion.div>

              {/* Third Service Block */}
              <motion.div
                className="col-lg-3 col-md-6 col-sm-6"
                initial={{ opacity: 0, x: 100 }}
                animate={
                  inView3 ? { opacity: 1, x: 0 } : { opacity: 0, x: 100 }
                }
                transition={{ duration: 0.6, delay: 0.4 }}
                ref={ref3}
              >
                <div className="service_block style_2">
                  <div className="service_icon">
                    <img src="assets/images/icons/2.svg" alt="Icon Dollar" />
                  </div>
                  <div className="service_content">
                    <h3 className="service_title">
                      <a href="">
                        Access to Banking Services <br />
                        <br />
                      </a>
                    </h3>
                    <div className="mb-0">
                      <p
                        className="mb-0"
                        style={{ display: "flex", gap: "10px" }}
                      >
                        <span>1.</span> Account Closure
                      </p>
                      <p
                        className="mb-0"
                        style={{ display: "flex", gap: "10px" }}
                      >
                        <span>2.</span> Funds getting stuck
                      </p>

                      {isExpanded.service3 && (
                        <>
                          {" "}
                          <p
                            className="mb-0"
                            style={{ display: "flex", gap: "10px" }}
                          >
                            <span>3.</span> Getting a bank account
                          </p>
                          <p
                            className="mb-0"
                            style={{ display: "flex", gap: "10px" }}
                          >
                            <span>4.</span> Maintaining Relations
                          </p>
                        </>
                      )}
                    </div>
                    <button
                      className=" p-0"
                      onClick={() => toggleExpand("service3")}
                    >
                      {isExpanded.service3 ? "Show Less" : "Read More"}
                    </button>
                  </div>
                </div>
              </motion.div>

              {/* Fourth Service Block */}
              <motion.div
                className="col-lg-3 col-md-6 col-sm-6"
                initial={{ opacity: 0, x: 100 }}
                animate={
                  inView4 ? { opacity: 1, x: 0 } : { opacity: 0, x: 100 }
                }
                transition={{ duration: 0.6, delay: 0.6 }}
                ref={ref4}
              >
                <div className="service_block style_2">
                  <div className="service_icon">
                    <img src="assets/images/icons/4.svg" alt="Icon Dollar" />
                  </div>
                  <div className="service_content">
                    <h3 className="service_title">
                      <a href="">Technological Advancements</a>
                    </h3>
                    <div className="mb-0">
                      <p
                        className="mb-0"
                        style={{ display: "flex", gap: "10px" }}
                      >
                        <span>1.</span> Investing in right technology
                      </p>

                      {isExpanded.service4 && (
                        <>
                          {" "}
                          <p
                            className="mb-0"
                            style={{ display: "flex", gap: "10px" }}
                          >
                            <span>2.</span> Integration Challenges
                          </p>
                        </>
                      )}
                    </div>
                    <button
                      className=" p-0"
                      onClick={() => toggleExpand("service4")}
                    >
                      {isExpanded.service4 ? "Show Less" : "Read More"}
                    </button>
                  </div>
                </div>
              </motion.div>

              {/* Fifth Service Block */}
              <motion.div
                className="col-lg-3 col-md-6 col-sm-6"
                initial={{ opacity: 0, x: 100 }}
                animate={
                  inView5 ? { opacity: 1, x: 0 } : { opacity: 0, x: 100 }
                }
                transition={{ duration: 0.6, delay: 0.8 }}
                ref={ref5}
              >
                <div className="service_block style_2">
                  <div className="service_icon">
                    <img src="assets/images/icons/5.svg" alt="Icon Dollar" />
                  </div>
                  <div className="service_content">
                    <h3 className="service_title">
                      <a href="">Limited Advocacy and Representation</a>
                    </h3>
                    <p
                      className="mb-0"
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <span> 1.</span> Lack of unified Voice
                    </p>
                  </div>
                  <button
                    className=" p-0"
                    onClick={() => toggleExpand("service6")}
                  >
                    {isExpanded.service4 ? "Show Less" : "Read More"}
                  </button>
                </div>
              </motion.div>
            </div>
          </div>
        </section>
        {/* Service Section - End
  ================================================== */}

        {/* Benefits Section - Start
================================================== */}
        <MsbBenefits />
        {/* Benefits Section - End
================================================== */}
       
        {/* Video GalleryTestimonials Section - End
  ================================================== */}

        {/* Pricing Section - Start
    ================================================== */}
        <PricingSection />
        {/* Pricing Section - End
    ================================================== */}
    
     

      
      </main>
    </div>
  );
};

export default Home;
